<template>
      <div class= "footer">

       <!-- Copyright -->
<div class="footer-copyright text-center py-3">© 2022 Copyright: GitRoss2021
  
</div>

    </div>
    
</template>

<script>
export default {

}
</script>

<style scoped>
.footer {
            position: fixed;
            
            bottom: 0px;
            width: 100%;
            /* Height of the footer*/ 
            height: 40px;
            background: rgb(177, 177, 177);
        }
div{background-color:#b1b1b1;
}

.footer:hover{
    transform: scale(1.2);
}

</style>